import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { AuthProvider } from "./context/AuthContext";
import { ThemeProvider } from "./context/ThemeContext";
import { Layout } from "./components/Layout";
import Home from "./pages/Home";
import Services from "./pages/Services";
import LetsBuild from "./pages/LetsBuild";
import Tools from "./pages/Tools";
import WhoWeAre from "./pages/WhoWeAre";
import AdminLogin from "./pages/AdminLogin";
import AdminDashboard from "./pages/AdminDashboard";

const withLayout = (el) => <Layout>{el}</Layout>;

function App() {
  return (
    <div className="App">
      <ThemeProvider>
        <AuthProvider>
          <BrowserRouter>
            <Routes>
              <Route path="/" element={withLayout(<Home />)} />
              <Route path="/services" element={withLayout(<Services />)} />
              <Route path="/lets-build" element={withLayout(<LetsBuild />)} />
              <Route path="/tools" element={withLayout(<Tools />)} />
              <Route path="/who-we-are" element={withLayout(<WhoWeAre />)} />
              <Route path="/admin" element={<AdminLogin />} />
              <Route path="/admin/dashboard" element={<AdminDashboard />} />
            </Routes>
          </BrowserRouter>
        </AuthProvider>
      </ThemeProvider>
    </div>
  );
}

export default App;
